import { useState } from 'react';

import { referralLink, shareText } from '@/features/referrals/share-message';
import { track } from '@/services/analytics';

interface ShareButtonProps {
  collectionTitle: string;
  /** Код приглашения владельца работы; без него делимся обычной ссылкой. */
  referralCode?: string | undefined;
  /** Адрес приложения. Параметром — чтобы поведение проверялось без window. */
  origin?: string | undefined;
}

/**
 * «Поделиться» — текст о работе и ссылка-приглашение.
 *
 * Ссылка ведёт на приложение, а не на картинку: подписанная ссылка на
 * изображение живёт час и протухла бы прямо в чужой переписке. Само
 * нажатие ничего не начисляет — награда приходит, только когда пришедший
 * по ссылке сделает свой первый портрет (qualify_referral на сервере).
 */
export function ShareButton({ collectionTitle, referralCode, origin }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  async function handleClick() {
    // Само нажатие ничего не начисляет — но именно с него начинается
    // реферальная часть цикла, и без него её не измерить.
    track('share_clicked', { withReferral: Boolean(referralCode) });

    const url = referralLink(origin ?? window.location.origin, referralCode);
    const text = shareText(collectionTitle);

    if (navigator.share) {
      try {
        await navigator.share({ title: collectionTitle, text, url });
      } catch {
        // Пользователь закрыл системный диалог — не ошибка.
      }
      return;
    }

    await navigator.clipboard.writeText(`${text} ${url}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button
      type="button"
      onClick={() => void handleClick()}
      className="btn btn-secondary px-4 py-2 text-sm"
    >
      {copied ? 'Ссылка скопирована' : 'Поделиться'}
    </button>
  );
}
